import { CommonModule } from '@angular/common';
import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
    MAT_DIALOG_DATA,
    MatDialogModule,
    MatDialogRef,
} from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { NoteSection } from 'app/core/user-notes/user-notes.types';
import { QuillViewComponent } from 'ngx-quill';

@Component({
    selector: 'app-infos-dialog',
    templateUrl: './infos-dialog.component.html',
    standalone: true,
    encapsulation: ViewEncapsulation.None,
    imports: [
        CommonModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        MatExpansionModule,
        QuillViewComponent,
    ],
})
export class InfosDialogComponent {
    sections: NoteSection[];

    constructor(
        private _dialogRef: MatDialogRef<InfosDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { sections: NoteSection[] },
    ) {
        this.sections = (data?.sections ?? []).filter(
            (section) => section.active,
        );
    }

    close(): void {
        this._dialogRef.close();
    }
}
